// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
// import TimePicker from 'react-times';
// import 'react-times/css/material/default.css';
// import 'react-times/css/classic/default.css';
import { Multiselect } from 'react-widgets';
import TimePicker from 'react-gradient-timepicker';




class CreateFixture extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      selected_one: {
        venue: this.props.venue ? this.props.venue : '',
        game_type: '',
        courts: [],
        no_of_courts: 0,
        game_level_id: 1,
        age_group_id: '',
        days: [],
        start_time: '00:00',
        end_time: '00:00',
        price: 200,
        fixture_name: '',
        max_sub: 30,
        batch_size: 14,
        reason: '',
        skill_matching:false
      },
      venues: [],
      games: [],
      game_types: [],
      courts_arr: [],
      data_uploaded: false,
      data_error: false,
      game_levels: [],
      age_groups: [],
      selected_buddies: [],
      buddies: [],
      temp_buddies: [],
      dialog_open_court_list: false,
      dialog_open_failed_list:false,
      available_court_list: [],
      blocked_court_list: [],
      total_slots: 0,
      message: '',
      no_of_available_slots: 0,
      no_of_blocked_slots: 0,
      blocked_for_bulk: false,
      previous_bulk_booking: '',
      block_state: true,
      time: '10:00',
      game_id: 1,
      game_type_specific_groups:[],
      buddy_availability_dialog:false,
      not_eligible_buddies:[]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.handleGameChange = this.handleGameChange.bind(this);
    this.onStartTimeChange = this.onStartTimeChange.bind(this);
    this.onEndTimeChange = this.onEndTimeChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.postCreate = this.postCreate.bind(this);
    this.handleGameTypeChange = this.handleGameTypeChange.bind(this);
  }


  componentDidMount() {
    this.getAllBuddies()
    this.getFixtureList();
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues,age_groups: data.age_groups },()=>{this.setData(data)}))
       .catch(error => error);
  }

  getAllBuddies(){
    const url = `${getLocationOrigin()}/cm/get_buddies/?venue=${this.state.selected_one.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({buddies:data.buddies});
    }).catch(error => error);
    }

  postCreateFixture(data,props) {
    const url = `${getLocationOrigin()}/eagleeye/create_fixture/`;
    const options = {...defaultOptions};
    var venue = data.venue
    var game_type = data.game_type
    var bud_ids = []
    for( var i in this.state.selected_buddies)
    {
      bud_ids.push(this.state.selected_buddies[i].id)
    }

    if(!data.venue){venue=this.state.venues[0].id}
    if(!data.game_type){game_type=this.state.game_types[0].pk}

    var court_bookings = []
    // if(this.state.available_court_list.length == 0 && this.state.selected_one.courts.length > 0){
    //   alert("No slots available")
    // }
    // else{
    //   for( var i in this.state.available_court_list)
    //   {
    //     court_bookings.push(this.state.available_court_list[i].id)
    //   }
    // }
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'court_booking_ids':court_bookings,
                        'venue_id': venue,
                        'game_type_id': game_type,
                        'details':data,
                        // 'courts': data.courts,
                        // 'days': data.days,
                        // 'no_of_courts': data.no_of_courts,
                        // 'game_level_id': data.game_level_id,
                        // 'age_group_id': data.age_group_id,
                        // 'start_time': data.start_time,
                        // 'end_time': data.end_time,
                        // 'price': data.price,
                        // 'day_of_week': data.dow,
                        // 'fixture_name': data.fixture_name,
                        // 'max_sub': data.max_sub,
                        // 'batch_size': data.batch_size,
                        // 'reason': data.reason,
                        'buddies':bud_ids
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)    // first then()
      .then(parseJSON)
      .then((response) => {        
        if(response.success){                      
          if(response.not_eligible_buddies && response.not_eligible_buddies.length > 0){
            this.setState({not_eligible_buddies:response.not_eligible_buddies,buddy_availability_dialog:true})
          }
          else{
            alert(response.message);
            window.location.reload()
          }
        }
        else{
          alert(response.message);
        }
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  check_availability(data,props) {
    if(data.courts.length === 0){
      alert("select court")
    }
    else if(data.days.length === 0){
        alert("select day")
    }
    else if(data.start_time === ''){
        alert("Enter Start Time")
    }
    else if(data.end_time === ''){
        alert("Enter End Time")
    }
    else if(data.reason === ''){
      alert("Enter Reason")
    }
  else{
    this.setState({loading:true})
    // var date = moment(data.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    // var ending_date = moment(data.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/eagleeye/check_availability_for_bulkbooking/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'venue': data.venue,
                        'courts':data.courts,
                        'days':data.days,
                        'game_type_id': data.game_type,
                        'start_time': data.start_time,
                        'end_time': data.end_time,
                        'reason':data.reason,
                        'is_fixture':true
                      });
    console.log('Going to fetch');
    console.log(options['body'])
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {  
        console.log('response')
        console.log(response)    
        this.setState({loading:false})
        if(response.success == false){
          alert(response.message)
        }
        else{
          if(response.available_slot.length > 0 || response.blocked_slot.length > 0 || response.total_slots > 0 || response.previous_bulk_booking ){
              this.setState({dialog_open_court_list:true, available_court_list:response.available_slot, blocked_court_list:response.blocked_slot, total_slots:response.total_slots ,message:response.message,no_of_available_slots:response.available_slot.length,no_of_blocked_slots:response.blocked_slot.length}); 
              // if(response.available_for_bulk && response.available_for_bulk.length > 0){
              //   this.setState({ total_slots:response.total_slots,no_of_available_slots:(response.available_slot.length + response.available_for_bulk.length),message:response.message,available_for_bulk:response.available_for_bulk})
              // } 
              if(response.blocked_for_bulk && response.blocked_for_bulk){
                this.setState({total_slots:response.total_slots ,no_of_available_slots:response.available_slot.length,blocked_for_bulk:response.blocked_for_bulk,message:response.message,no_of_blocked_slots:(response.blocked_slot.length+response.blocked_for_bulk.length)})
              }
              if(response.previous_bulk_booking){
                this.setState({previous_bulk_booking:response.previous_bulk_booking});
              }
            } 
          else{
            alert("No Slot Matched")
          } 
        }
         
          // alert(response.message);
          // props.history.goBack();
        })
      .catch((error) => {
        console.log(error);
        alert(error.message);
        this.setState({loading:false})
      });
    }
  }

  dayOfWeek() {
    return [
      {id:0, name: 'Monday'},
      {id:1, name: 'Tuesday'},
      {id:2, name: 'Wednesday'},
      {id:3, name: 'Thursday'},
      {id:4, name: 'Friday'},
      {id:5, name: 'Saturday'},
      {id:6, name: 'Sunday'},
    ]
  }

  setData(data) {
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    if(!this.state.selected_one.venue){
      new_selected_one['venue'] = data.venues[0].id
      new_selected_one['game_type'] = data.venues[0].games[0].game_types[0].pk
      new_selected_one['game_level_id'] = data.venues[0].game_levels[0].pk
      // new_selected_one['age_group_id'] = data.age_groups[0].id
      let games = data.venues[0].games
      new_selected_one['game_id'] = data.age_groups[0].id
      let game_types =  games[0].game_types
      let courts_arr = games[0].courts

      courts_arr = courts_arr.sort((c1, c2) => {
        return c1.name.localeCompare(c2.name)
      })

      let game_levels = data.venues[0].game_levels
      // if(game_types[0].age_groups){
      //   new_selected_one['age_group_id'] = game_types[0].age_groups[0].id
      // }
      this.setState({selected_one: new_selected_one,game_types:game_types,courts_arr:courts_arr,game_levels:game_levels,games:games,game_type_specific_groups:game_types[0].age_groups});
    }
    else{
      let venue = data.venues.find(each=> each.id == this.state.selected_one.venue)
      console.log('venue',venue)
      new_selected_one['game_type'] = venue.games[0].game_types[0].pk
      // new_selected_one['age_group_id'] = data.age_groups[0].id
      let games = venue.games
      let game_types = venue.games[0].game_types
      let courts_arr = venue.games[0].courts

      courts_arr = courts_arr.sort((c1, c2) => {
        return c1.name.localeCompare(c2.name)
      })
      var game_levels = []
      var first_game_id = games[0].game_id

      venue.game_levels.forEach(function (game) {
        if (game.game.pk == first_game_id) {
          game_levels.push(game);
        }
      });
      new_selected_one['game_level_id'] = game_levels[0].pk
      // console.log('track age_groups',game_types[0])
      // if(game_types[0].age_groups.length() > 0){
      //   new_selected_one['age_group_id'] = game_types[0].age_groups[0].id
      // }
      // let game_levels = venue.game_levels
      this.setState({game_id:first_game_id, selected_one: new_selected_one,game_types:game_types,courts_arr:courts_arr,game_levels:game_levels,games:games, game_type_specific_groups:game_types[0].age_groups});
    }  
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    if(name == 'courts'){
      var temp = []
      temp.push(event.target.value)
    }
    else if(name == 'price' && event.target.value == ''){
      new_selected_one[name] = 0
    }
    else{
      new_selected_one[name] = event.target.value
    }
    this.setState({selected_one: new_selected_one});
  }

  handleVenueChange(event){
    const name = event.target.name
    const value = event.target.value
    const data = this.state.venues.find(each=> each.id == value)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value[name] = value
    new_value['game_type'] = data.game_types[0].pk
    new_value['game_level_id'] = data.game_levels[0].pk
    this.setState({game_types:data.game_types, selected_one:new_value,courts_arr:data.game_types[0].courts,game_levels:data.game_levels})
  }

  handleGameChange(event){
    const name = event.target.name
    const value = event.target.value
    const data = this.state.games.find(each=> each.game_id == value)
    const venue = this.state.venues.find(each=> each.id == this.state.selected_one.venue)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['game_type'] = data.game_types[0].pk
    var gt_specific_groups = data.game_types[0].age_groups
    var game_types = data.game_types
    var courts = data.courts
    var game_levels = []
      venue.game_levels.forEach(function (game) {
        if (game.game.pk == value) {
          game_levels.push(game);
        }
      });
    new_value['game_level_id'] = game_levels[0].pk  
    // if(gt_specific_groups){
    //   new_value['age_group_id'] = gt_specific_groups[0].id
    // }    
    this.setState({courts_arr:courts,game_types:game_types,selected_one:new_value,game_id:value,game_levels:game_levels})
  }

  handleGameTypeChange(event) {
    const name = event.target.name
    const value = event.target.value
    var game_type = this.state.game_types.find(each => each.pk == value)
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one[name] = value
    var gt_specific_groups = game_type.age_groups
    // if(gt_specific_groups){
    //   new_selected_one['age_group_id'] = gt_specific_groups[0].id
    // } 
    this.setState({selected_one:new_selected_one, game_type_specific_groups:gt_specific_groups})
  }

  onStartTimeChange(options) {
    console.log('options',options)
    console.log(options['format24'])
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['start_time'] = options['format24']
    this.setState({selected_one: new_value});
  }

  onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['end_time'] = options['format24']
    this.setState({selected_one: new_value});
  }

  handleSubmit(event) {
    if(this.state.selected_one.days.length === 0){
        alert("select day")
    }
    else if(this.state.selected_one.start_time === '00:00'){
        alert("Enter Start Time")
    }
    else if(this.state.selected_one.end_time === '00:00'){
        alert("Enter End Time")
    }
    else if(this.state.selected_one.reason === ''){
      alert("Enter Reason")
    }
    else if(this.state.selected_one.age_group_id === ''){
      alert("Enter Age Group")
    }
    else{
      event.preventDefault();
      if(this.state.selected_one.courts.length > 0){
        this.check_availability(this.state.selected_one, this.props);
      }
      else{
        this.postCreateFixture(this.state.selected_one,this.props)
      }
      console.log('post');
      console.log(this.state);
    }
  }

  postCreate(event){
    event.preventDefault();
    this.postCreateFixture(this.state.selected_one,this.props)
  }

  handleDaysCheckbox = (e, s) => {
    var new_value =  Object.assign({}, this.state.selected_one);
    const dayscheckedBoxes = [...this.state.selected_one.days];
    if(e.target.checked) {
        dayscheckedBoxes.push(s)
    } else {
        const index = dayscheckedBoxes.findIndex((ch) => ch.id === s.id);
        dayscheckedBoxes.splice(index, 1);
    }
    new_value['days'] = dayscheckedBoxes
    this.setState({selected_one:new_value});
    console.log('day_of_week',dayscheckedBoxes)
  }

  handleSkillCheckingCheckbox = (e) => {
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['skill_matching'] = e.target.checked
    this.setState({selected_one:new_value});
  }


   handleCourtCheckbox = (e, s) => {
    var new_value =  Object.assign({}, this.state.selected_one);
    const courtCheckBox = [...this.state.selected_one.courts];
    if(e.target.checked) {
        courtCheckBox.push(s)
    } else {
        const index = courtCheckBox.findIndex((ch) => ch.id === s.id);
        courtCheckBox.splice(index, 1);
    }
    new_value['courts'] = courtCheckBox
    new_value['no_of_courts'] = courtCheckBox.length
    this.setState({selected_one:new_value});
    console.log('courts',courtCheckBox)
  }

  handleOpen = () => {
    this.setState({dialog_open: true, dialog_open_court_list:true,dialog_open_failed_list:true});
  };

  handleClose = () => {
    this.setState({dialog_open: false, dialog_open_court_list:false,dialog_open_failed_list:false,previous_bulk_booking:false});
  };

  handleBuddyClose = () => {
    this.setState({buddy_availability_dialog:false});
    window.location.reload()
  }

  onSelect(optionsList, selectedItem) {
    this.state.temp_buddies.push(optionsList)
    this.setState({ selected_buddies: this.state.temp_buddies});
  }

  onChange(dataItem,event){
    this.setState({selected_buddies:dataItem.map(x =>x)});
  }

  render() {
    console.log(this.state.selected_one);
    console.log('sucess');
    console.log(this.state.game_id)
    console.log(this.state.selected_one.start_time);

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.postCreate}
      />,
    ];

    const okaction = [
      <FlatButton
        label="OK"
        primary={true}
        onClick={this.handleBuddyClose}
      />
    ];

    var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]

    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12 label_blue_1">
            Create Fixture
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Name
              </div>
              <input type="text" style={styles.input} name="fixture_name" className="required" value={this.state.value}
                onChange={this.handleChange} placeholder="Siemens Wednesday 6:30 - 8:00am"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.props.venue ? this.props.venue : this.state.value}
                onChange={this.handleVenueChange} disabled={this.props.venue ? 'disabled':''}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game
              </div>
              <select name="game" style={styles.item_body} className="col-md-6" value={this.state.game_id} onChange={this.handleGameChange}>
                {
                  this.state.games.map((x, index) => (
                  <option key={x.game_id} value={x.game_id}>{x.game}</option>
                  ))
                }
              </select>
            </div>


            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6" value={this.state.selected_one.game_type} onChange={this.handleGameTypeChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            { this.state.courts_arr.length > 0 ?
              <div style={styles.items} className="col-md-12">
                <div style={styles.court_list}>
                  {
                    this.state.courts_arr.map((x, index) => (
                    <label>
                      <input type="checkbox"
                      checked={this.state.selected_one.courts.find((ch) => ch.id === x.id)}
                      onChange={(e) => this.handleCourtCheckbox(e, x)}
                    />
                    <div style={{fontSize:12}} key={x.id} value={x.id}>{x.name}</div>
                    </label>
                    ))
                  }
                </div>
              </div>
            :
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Number of courts
                </div>
                <input type="number" style={styles.input} className="required" name="no_of_courts"
                  onChange={this.handleChange}/>
              </div>
            }

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Is skill matching required ?
              </div>
              <label>
                      <input type="checkbox"
                      checked={this.state.selected_one.skill_matching}
                      onChange={(e) => this.handleSkillCheckingCheckbox(e)}
                    />
              </label>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Levels
              </div>
              <select name="game_level_id" style={styles.item_body} value={this.state.selected_one.game_level_id} className="col-md-6" onChange={this.handleChange}>
                {
                  this.state.game_levels.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game.name + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Reason
              </div>
              <select name="reason" className="col-md-6" style={styles.item_body}
                onChange={this.handleChange}>
                <option value>-------</option>
                <option key='0' value='0'>Academy</option>
                <option key='1' value='1'>Improve</option>
                <option key='2' value='2'>Play</option>
                <option key='3' value='3'>Customer</option>
                <option key='4' value='4'>Tournament</option>
                <option key='5' value='5'>Other</option>
              </select>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_group_id" style={styles.item_body} className="col-md-6" onChange={this.handleChange}>
                <option> --select-- </option>
                {
                  this.state.game_type_specific_groups.length > 0 ?
                  this.state.game_type_specific_groups.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.abbreviation}</option>
                  ))
                  :
                  this.state.age_groups.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.abbreviation}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div className="col-md-12" style={styles.court_list}>
                  {
                    this.dayOfWeek().map((x, index) => (
                    <label>
                      <input type="checkbox"
                      checked={this.state.selected_one.days.find((ch) => ch.id === x.id)}
                      onChange={(e) => this.handleDaysCheckbox(e, x)}
                    />
                    <div style={{paddingLeft: '3%', paddingRight:'3%'}} key={x.id} value={x.id}>{x.name}</div>
                    </label>
                    ))
                  }
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>Start Time </span>
                    </div>
                    <div className='col-md-6'>

                        <TimePicker
                          time={this.state.selected_one.start_time}
                          headerColor='#84888A'
                          color1='#84888A'
                          className="timepicker"
                          placeholder="Start Time"
                          onSet={this.onStartTimeChange}
                        />
                    </div>
                </div>
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>End Time </span>
                    </div>
                    <div className='col-md-6'>

                      <TimePicker
                            time={this.state.selected_one.end_time}
                            headerColor='#84888A'
                            color1='#84888A'
                            className="timepicker"
                            placeholder="End Time"
                            onSet={this.onEndTimeChange}
                          />
                    </div>
                </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Subscribers
              </div>
              <input type="number" style={styles.input} name="max_sub" className="required"
                value={this.state.selected_one.max_sub} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Vote In
              </div>
              <input type="number" style={styles.input} name="batch_size" className="required"
                value={this.state.selected_one.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="number" style={styles.input} name="price" className="required"
                value={this.state.selected_one.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Buddies
              </div>
              <div className="col-md-6">
                <Multiselect
                  id="1"  
                  placeholder="Buddies"
                  data={this.state.buddies}
                  value = {this.state.selected_buddies}
                  textField='buddy'
                  onSelect={this.onSelect} 
                  onChange={this.onChange}
                  filter='contains' 
                 />
              </div>
            </div>

            <div style={styles.items,{color:'red',fontSize:'1em',paddingLeft:'5%'}} className='col-md-12'>
                Please ensure that there are free slots before you submit
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
              {this.state.previous_bulk_booking.length > 0 ?
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                    <Dialog
                      actions={okaction}
                      modal={false}
                      open={this.state.previous_bulk_booking}
                      onClick={this.handleClose}
                      autoDetectWindowHeight={true}
                      autoScrollBodyContent={true}
                      scroll={scroll}
                      dividers={scroll === 'paper'}
                    >

                    <div style={styles.main_header} className="col-md-12">
                      <h4 style={{textAlign:'center'}}>These slots are not available for bulk booking ,so change date or time and try again </h4>
                    </div>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      <div className="col-md-3">
                              Date
                      </div>
                      
                      <div className="col-md-3">
                              Time
                      </div>
                      
                      <div className="col-md-3">
                              Days
                      </div>
                      <div className="col-md-3">
                              Court
                      </div>
                    </div>
                      <div className="col-md-12" style={{flexDirection:'row',textAlign:'center','backgroundColor':"#cfd4d3",'padding':"5px"}}>
                          {this.state.previous_bulk_booking && this.state.previous_bulk_booking.map((Bulk_book,index) =>
                          <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>  
                            <div className="col-md-3">
                              {Bulk_book.start_date} - {Bulk_book.end_date}
                            </div>
                            
                            <div className="col-md-3">
                              {Bulk_book.start_time} - {Bulk_book.end_time}
                            </div>
                            <div className="col-md-3" >
                              {Bulk_book.days}
                            </div>
                            <div className="col-md-3">
                              {Bulk_book.court.map((crt,index) =>
                                <div><label>{crt.name}
                                </label></div>
                                )}
                            </div>
                          </div>
                          )}
                      </div>
                      </Dialog>
                  </div>
                  :
              <Dialog
                  actions={actions}
                  modal={false}
                  open={this.state.dialog_open_court_list}
                  onRequestClose={this.handleClose}
                  scroll={scroll}
                  dividers={scroll === 'paper'}
                >
            <div>
            {this.state.blocked_court_list.length > 0 &&
              <div style={styles.main_header} className="col-md-12">
                <h4 style={{textAlign:'center'}}>{this.state.block_state === true ? "Following Slots are not available, press Continue to book the available slots or cancel."
                :
                `${this.state.blocked_court_list.length} slots are blocked, press continue to un-block`
              }
                </h4>
              </div>
            }
            {this.state.block_state === true &&
            <div>
              {this.state.blocked_court_list.length > 0 ?
              <div>
              {this.state.blocked_court_list.map((list,index)=>
              <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                <div className="col-md-4">
                  {list.court.name}
                </div>
                <div className="col-md-4">
                  {list.date}
                </div>
                <div className="col-md-4">
                  {list.start_time}
                </div>
                </div>
                )}
                </div>
                :
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                  <div>All slots Available!!</div>
                </div>
              }
              </div>
              }
              </div>
            </Dialog>
            }
            { this.state.not_eligible_buddies &&
              <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                <Dialog
                  actions={okaction}
                  modal={false}
                  open={this.state.buddy_availability_dialog}
                  onClick={this.handleBuddyClose}
                  autoDetectWindowHeight={true}
                  autoScrollBodyContent={true}
                  scroll={scroll}
                  dividers={scroll === 'paper'}
                >

                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}>These buddies are not available so edit the fixture and replace them </h4>
                </div>
                {
                  this.state.not_eligible_buddies.map((buddy,index)=>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      {buddy.name} is tagged to fixture {buddy.fixture_value}
                    </div>
                    )
                }
                </Dialog>
              </div>
              }
          </div>
        </form>
      </div>

      </div>
              
    );
  }
}

export default CreateFixture;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/createFixture/index.js